/**
 * Hulpfuncties voor de oplopende tellers op de startpagina.
 *
 * Deze logica staat los van het component zodat ze zonder browser te testen is.
 *
 * (c) TwistedMinds, Gerry Uytdenhouwen - 16 september 2026
 */

/**
 * Vertraagt het einde van de animatie, zodat de teller uitloopt in plaats van
 * abrupt te stoppen. Dit is de gebruikelijke "ease-out cubic".
 *
 * @param {number} verstrekenDeel Waarde van 0 tot 1.
 * @returns {number} Waarde van 0 tot 1.
 */
export function easeOutCubic(verstrekenDeel) {
    const begrensd = Math.min(Math.max(verstrekenDeel, 0), 1);
    return 1 - Math.pow(1 - begrensd, 3);
}

/**
 * Berekent welk getal er op een bepaald moment van de animatie getoond wordt.
 *
 * @param {number} eindwaarde Het getal waar de teller op uitkomt.
 * @param {number} verstrekenTijd Milliseconden sinds de start.
 * @param {number} looptijd Totale duur van de animatie in milliseconden.
 * @returns {number} Een geheel getal tussen 0 en de eindwaarde.
 */
export function currentCountValue(eindwaarde, verstrekenTijd, looptijd) {
    if (looptijd <= 0) {
        return eindwaarde;
    }
    return Math.round(eindwaarde * easeOutCubic(verstrekenTijd / looptijd));
}

/**
 * Zet een getal om naar de Belgisch-Nederlandse schrijfwijze met punten als
 * duizendtalscheiding: 22058 wordt 22.058.
 *
 * @param {number} getal
 * @returns {string}
 */
export function formatCount(getal) {
    return Math.round(getal)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
